import { render } from "./BecomeACreatorSection.vue?vue&type=template&id=39e16d33"
import script from "./BecomeACreatorSection.vue?vue&type=script&lang=js"
export * from "./BecomeACreatorSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__